import React from 'react';

import { LayerLoading } from '../layer/loading';
import { RotationLoading } from '../rotation/loading';
import { type LoadingProps } from '../types';

const TimelineLoading = ({ size = 'medium', numberOfDays, variant }: LoadingProps): JSX.Element => {
	const sectionCount = numberOfDays === 1 ? 4 : numberOfDays;

	return (
		<LayerLoading variant={variant} size={size} numberOfDays={sectionCount}>
			<RotationLoading variant={variant} size={size} numberOfDays={sectionCount} />
		</LayerLoading>
	);
};

export { TimelineLoading };
